export default function ElementLegacyFundMap() {
  document.querySelectorAll(".legacy-fund-map").forEach(root => {
    const picked = root.querySelector(".picked");
    if (!picked) {
      return;
    }

    const pathsForRegion = region =>
      root.querySelectorAll(`path[data-region="${region}"]`);

    root.querySelectorAll("template[data-region]").forEach(template => {
      pathsForRegion(template.getAttribute("data-region")).forEach(path => {
        const title = path.querySelector("title");
        path.classList.add("is-funded");
        path.setAttribute("tabindex", "0");
        path.setAttribute("role", "button");
        path.setAttribute("aria-pressed", "false");
        if (title) {
          path.setAttribute("aria-label", title.textContent);
        }
      });
    });

    const handleOpen = region => {
      const template = root.querySelector(`template[data-region="${region}"]`);
      if (!template) {
        return;
      }

      picked.innerHTML = "";
      picked.appendChild(template.content.cloneNode(true));

      root.querySelectorAll("path.is-selected").forEach(path => {
        path.classList.remove("is-selected");
        path.setAttribute("aria-pressed", "false");
      });

      pathsForRegion(region).forEach(path => {
        path.classList.add("is-selected");
        path.setAttribute("aria-pressed", "true");
      });
    };

    const handleActivate = event => {
      if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") {
        return;
      }

      const path = event.target.closest("path[data-region].is-funded");
      if (!path) {
        return;
      }

      if (event.type === "keydown") {
        event.preventDefault();
      }

      handleOpen(path.getAttribute("data-region"));
    };

    root.addEventListener("click", handleActivate);
    root.addEventListener("keydown", handleActivate);

    handleOpen("canterbury");
  });
}
